var samsung_AA59_00489A = {
    name: "AA59_00489A",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,223,218,170,136],
        },
        {
            function: "KEY_CYCLEWINDOWS",
            name: "KEY_CYCLEWINDOWS",
            icon: "KEY_CYCLEWINDOWS",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,191,234,170,136],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,239,214,170,136],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,183,246,170,136],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,215,238,170,136],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,247,213,170,136],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,187,245,170,136],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,219,237,170,136],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,235,235,170,136],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,181,251,170,136],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,213,247,170,136],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,189,245,106,136],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,170,255,170,136],
        },
        {
            function: "ChList",
            name: "ChList",
            icon: "ChList",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,173,175,110,136],
        },
        {
            function: "PreCh",
            name: "PreCh",
            icon: "PreCh",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,174,253,106,136],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,171,254,170,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,173,253,170,136],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,221,237,106,136],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,235,90,238,136],
        },
        {
            function: "Content",
            name: "Content",
            icon: "Content",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,186,174,190,136],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,218,246,234,136],
        },
        {
            // function: "HDMI",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,173,238,213,136],
        },
        {
            function: "Tools",
            name: "Tools",
            icon: "Tools",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,173,222,214,136],
        },
        {
            function: "KEY_INFO",
            name: "KEY_INFO",
            icon: "KEY_INFO",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,170,191,234,136],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,253,106,174,136],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,190,186,174,136],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,183,93,174,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,222,182,174,136],
        },
        {
            function: "KEY_SELECT",
            name: "KEY_SELECT",
            icon: "KEY_SELECT",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,246,181,110,136],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,245,181,118,136],
        },
        {
            function: "KEY_EXIT",
            name: "KEY_EXIT",
            icon: "KEY_EXIT",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,181,189,218,136],
        },
        {
            function: "PorgB_PIP",
            name: "PorgB_PIP",
            icon: "PorgB_PIP",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,237,235,106,136],
        },
        {
            function: "ProgC_Standby",
            name: "ProgC_Standby",
            icon: "ProgC_Standby",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,182,251,106,136],
        },
        {
            function: "ProgD_Apps",
            name: "ProgD_Apps",
            icon: "ProgD_Apps",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,214,247,106,136],
        },
        {
            function: "E-manual",
            name: "E-manual",
            icon: "E-manual",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,170,175,250,136],
        },
        {
            function: "S.Mode",
            name: "S.Mode",
            icon: "S.Mode",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,173,190,218,136],
        },
        {
            function: "P.Mode",
            name: "P.Mode",
            icon: "P.Mode",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,246,234,218,136],
        },
        {
            function: "P.Size",
            name: "P.Size",
            icon: "P.Size",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,213,93,250,136],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,175,250,170,136],
        },
        {
            function: "SRS",
            name: "SRS",
            icon: "SRS",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,213,173,238,136],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,183,187,86,136],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,219,182,214,136],
        },
        {
            function: "KEY_FORWARD",
            name: "KEY_FORWARD",
            icon: "KEY_FORWARD",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,247,106,214,136],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,171,223,86,136],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,215,183,86,136],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,187,186,214,136],
        },
        {
            function: "TTX/MIX",
            name: "TTX/MIX",
            icon: "TTX/MIX",
            command: [68,0,4,36,2,22,2,36,2,127,6,201,17,148,17,38,2,211,183,42,253,95,235,117,218,136],
        },
    ]
}
export default samsung_AA59_00489A